import React, { useEffect, type ReactNode } from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';

import type { ViewDeadAirBroker } from './types';
import { ViewDeadAirContext } from './ViewDeadAirContext';

type ViewDeadAirProviderProps = {
	value: ViewDeadAirBroker | null;
	identity?: string;
	children: ReactNode;
};

export function ViewDeadAirProvider({
	value,
	identity,
	children,
}: ViewDeadAirProviderProps): React.JSX.Element {
	const isEnabled = fg('rovo_chat_track_view_dead_air');

	useEffect(() => {
		if (!isEnabled) {
			return;
		}
		if (identity !== undefined && value) {
			value.updateIdentity(identity);
		}
	}, [identity, value, isEnabled]);

	if (!isEnabled) {
		return <>{children}</>;
	}

	return <ViewDeadAirContext.Provider value={value}>{children}</ViewDeadAirContext.Provider>;
}
